import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProductMaterialAnalytics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_161_736",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_161_736)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.2 15.6C11.7 15.6 12.975 15.075 14.025 14.025C15.075 12.975 15.6 11.7 15.6 10.2C15.6 8.7 15.075 7.425 14.025 6.375C12.975 5.325 11.7 4.8 10.2 4.8C8.7 4.8 7.425 5.325 6.375 6.375C5.325 7.425 4.8 8.7 4.8 10.2C4.8 11.7 5.325 12.975 6.375 14.025C7.425 15.075 8.7 15.6 10.2 15.6ZM9.3 12.9V6.6H11.1V12.9H9.3ZM6.15 12.9V8.4H7.95V12.9H6.15ZM12.45 12.9V9.3H14.25V12.9H12.45ZM19.74 21L14.6325 15.8925C14.0175 16.3725 13.335 16.7437 12.585 17.0062C11.835 17.2687 11.04 17.4 10.2 17.4C8.19 17.4 6.4875 16.7025 5.0925 15.3075C3.6975 13.9125 3 12.21 3 10.2C3 8.19 3.6975 6.4875 5.0925 5.0925C6.4875 3.6975 8.19 3 10.2 3C12.21 3 13.9125 3.6975 15.3075 5.0925C16.7025 6.4875 17.4 8.19 17.4 10.2C17.4 11.04 17.2687 11.835 17.0062 12.585C16.7437 13.335 16.3725 14.0175 15.8925 14.6325L21 19.74L19.74 21Z",
			fill: "currentColor"
		})
	})]
});
export default SvgProductMaterialAnalytics;
